import {Modal} from 'antd'
import FullList from '../../../components/Common/Documents/List'
import React, {Component} from 'react'

class DocumentWidgetModal extends Component {
  render() {
    const {fullListVisible, fullListHandleCancel, upload} = this.props
    return (
      <Modal
        title="File List"
        visible={fullListVisible}
        onCancel={fullListHandleCancel}
        width={'95%'}
        footer={false}>
        <FullList {...this.props} allowUpload={upload} />
      </Modal>
    )
  }
}

export default DocumentWidgetModal
